import { render, staticRenderFns } from "./techprocessesMain.vue?vue&type=template&id=1708eacc&scoped=true&"
import script from "./techprocessesMain.vue?vue&type=script&lang=js&"
export * from "./techprocessesMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1708eacc",
  null
  
)

export default component.exports